import { render, staticRenderFns } from "./MitBorrowedList.vue?vue&type=template&id=4a35aba0&scoped=true"
import script from "./MitBorrowedList.vue?vue&type=script&lang=js"
export * from "./MitBorrowedList.vue?vue&type=script&lang=js"
import style0 from "./MitBorrowedList.vue?vue&type=style&index=0&id=4a35aba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a35aba0",
  null
  
)

export default component.exports